import React, { ReactElement } from 'react';
import './Loading.scss';
import { Oval } from 'react-loader-spinner';

interface Props {
  loading: boolean;
}

const Loading: React.FC<Props> = (props: Props): ReactElement => {
  if (props.loading) {
    return (
      <div className="Loading">
        <Oval
          color="#003366"
          secondaryColor="#e8e7e3"
          height={100}
          width={100}
        />
      </div>
    );
  }
  return <div></div>;
};

export default Loading;
